import { render, staticRenderFns } from "./JobExam.vue?vue&type=template&id=16fb98dc&"
import script from "./JobExam.vue?vue&type=script&lang=js&"
export * from "./JobExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports